const SimplifiedChineseLanguageMap = {
  guidenotupdated:
    '此社区翻译尚未更新为最新的Storybook版本。通过应用此翻译的中文指南中的更改来帮助我们更新它。',
  pullrequestmessage: 'Pull requests 欢迎他们',
};

export default SimplifiedChineseLanguageMap;
